import TyTopTips from './TyTopTips.vue'
export default TyTopTips



// WEBPACK FOOTER //
// ./src/components/ty-toptips/index.js